<template>
  <div class="t-weekly-grid">
    <cmp-calendar-body-header :type="2"></cmp-calendar-body-header>

    <div 
          v-for="col in 8" :key="'col_'+col"
          class="t-calendar-col"
          :class="{_first: col == 1}">
      <template v-if="col !== 1">
        <div class="t-calendar-cell" :class="{_today: (today + 1) === col}" v-for="time in 48" :key="'cell_'+time">
          <span>
            <!--<button @click.prevent="AddLesson(col - 1, time)" v-if="($route.name === 'courses_create') && (col > today)">-->
              <!--<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M8 1C8 0.449219 7.55225 0 7 0C6.44775 0 6 0.449219 6 1V6H1C0.447754 6 0 6.44922 0 7C0 7.55078 0.447754 8 1 8H6V13C6 13.5508 6.44775 14 7 14C7.55225 14 8 13.5508 8 13V8H13C13.5522 8 14 7.55078 14 7C14 6.44922 13.5522 6 13 6H8V1Z" fill="white"/>-->
              <!--</svg>-->
            <!--</button>-->
          </span>
        </div>
      </template>
    </div>
    <div class="t-calendar-time">
      <template v-for="time_value in time_grey">
        <span class="_grey">{{ time_value }}:00</span>
        <span class="_grey">{{ time_value }}:30</span>
      </template>
      <template v-for="time_value in time">
        <span>{{ time_value }}:00</span>
        <span>{{ time_value }}:30</span>
      </template>
      <template v-for="time_value in time_grey_2">
        <span class="_grey">{{ time_value }}:00</span>
        <span class="_grey">{{ time_value }}:30</span>
      </template>
    </div>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';
    import CalendarBodyHeader from './CalendarBodyHeader.vue'

    export default {
        props: ['lesson_index'],
        components: {
            'cmp-calendar-body-header': CalendarBodyHeader,
        },
        data(){
            return{
                time_grey: ['00', '01', '02', '03', '04', '05', '06'],
                time: ['07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
                time_grey_2: ['21', '22', '23']
            }
        },
        computed: {
            ...mapGetters('calendar', ['day_week_header', 'date_active', 'open_day', 'today'])
        },
        methods: {
            ...mapActions('calendar', ['SetOpenDay']),
            AddLesson(day_week, time){
                time = time / 2 - 0.5;
                let hours = Math.floor(time / 1);
                if(hours < 10)
                    hours = '0' + hours;

                let minutes = (time - hours) > 0 ? ':30' : ':00';

                let date = this.day_week_header[day_week - 1].value.getDate();
                this.SetOpenDay(date);
                time = hours + minutes;

                let month = '';
                if(date < this.date_active.getDate()){
                    if(date < 10 && this.date_active.getDate() > 20){
                        month = (this.date_active.getMonth() + 2)
                    } else{
                        month = this.date_active.getMonth() + 1;
                    }
                } else{
                    month = this.date_active.getMonth() + 1
                }

                date = new Date(this.date_active.getFullYear() + '.' + month + '.' + this.open_day);
                time = time.split(':');
                date.setHours(time[0]);
                date.setMinutes(time[1]);

                this.$parent.$parent.AddDate(date)
            }
        }
    }
</script>

<style lang="sass">
.t-weekly-grid
  width: 100%
  flex-wrap: wrap
  display: flex
  position: relative
  justify-content: space-between
  align-items: flex-start
.t-calendar-col
  flex: none
  width: calc((100% - 88px) / 7)
  &._first
    width: 88px

.t-calendar-time
  position: absolute
  display: flex
  flex-direction: column
  left: 8px
  bottom: 30px
  span
    margin-bottom: 23px
    line-height: 17px
    font-size: 14px
    color: $blue
    &._grey
      color: $grey
    &:last-child
      margin-bottom: 0

.t-calendar-cell
  height: 40px
  padding: 1px
  display: flex
  position: relative
  z-index: 10
  span
    width: 100%
    height: 100%
    border-radius: 4px
    border: 1px solid $disabled
    display: flex
    align-items: center
    justify-content: center
  &._today
    span
      border-color: $warning
  button
    cursor: pointer
    width: 35px
    height: 35px
    box-shadow: $shadow
    background: $blue_gradient
    border-radius: 50%
    display: flex
    align-items: center
    justify-content: center
    border: none
    outline: none
    transition: all .2s
    opacity: 0
  @media (min-width: 769px)
    &:hover
      button
        opacity: 1
</style>


// WEBPACK FOOTER //
// src/vue_components/Calendar/WeeklyGrid.vue